import block from 'bem-cn-lite';
import {FC, useState} from 'react';
import {Button, Checkbox, Modal, Text} from '@gravity-ui/uikit';
import {useMediaQuery} from 'react-responsive';
import {hideEDOBannerForever, markEDOBannerShownThisSession} from '@utils';
import BannerModalImage from '@assets/bannerEDO/BannerModalImage.png';
import BannerModalImageMobile from '@assets/bannerEDO/BannerModalImageMobile.png';
import MegaphoneIcon from '@assets/bannerEDO/megaphoneIconBannerEDO.svg';
import WarningIcon from '@assets/bannerEDO/warningIconBannerEDO.svg';

import './ModalBannerEDO.scss';

const b = block('modal-banner-edo');

interface ModalBannerEDOProps {
    visibility: boolean;
    stateModal: (value: boolean) => void;
}

export const ModalBannerEDO: FC<ModalBannerEDOProps> = ({visibility, stateModal}) => {
    const isSmallScreen = useMediaQuery({query: '(max-width: 1150px)'});
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const onCheckboxChange = (e: any, payload?: any) => {
        const next = payload?.checked ?? e?.target?.checked ?? false;

        setDontShowAgain(Boolean(next));
    };

    const onOk = () => {
        markEDOBannerShownThisSession();

        if (dontShowAgain) {
            hideEDOBannerForever();
        }

        stateModal(false);
    };

    return (
        <Modal open={visibility} className={b()}>
            <div className={b('container')}>
                <div className={b('image-container')}>
                    <img
                        src={isSmallScreen ? BannerModalImageMobile : BannerModalImage}
                        className={b('image')}
                        alt="EDO Banner"
                    />
                </div>

                <div className={b('content')}>
                    <div className={b('header')}>
                        <Text variant={isSmallScreen ? 'header-1' : 'display-2'}>
                            Маркированный товар «Честный знак» + ЭДО
                        </Text>
                    </div>

                    <div className={b('text-container')}>
                        <Text variant="body-2">Уважаемые покупатели!</Text>
                        <Text variant="body-2">
                            С 1 апреля 2026 года введён поэкземплярный учёт маркируемых товаров с
                            обязательной фиксацией всех операций (приёмка, перемещение, продажа) в
                            системе «Честный ЗНАК» через электронный документооборот (ЭДО).
                        </Text>
                        <Text variant="body-2">
                            Если вы закупаете маркируемый товар для перепродажи, убедитесь, что
                            между нами подключён ЭДО.
                        </Text>
                        <div className={b('note-item')}>
                            <img src={WarningIcon} alt="warning" />
                            <Text variant="body-2">
                                <Text className={b('bold-text')}>Важно:</Text> без ЭДО код
                                маркировки при продаже будет выведен из оборота —{' '}
                                <Text className={b('bold-text')}>
                                    перепродажа станет невозможной.
                                </Text>
                            </Text>
                        </div>

                        <div className={b('note-item')}>
                            <img src={MegaphoneIcon} alt="megaphone" />
                            <Text variant="body-2">
                                Рекомендуем не откладывать: с 2026 года передача маркированного
                                товара без ЭДО нарушает законодательство.
                            </Text>
                        </div>
                        <Text variant="body-2">
                            Для подключения ЭДО обратитесь к вашему менеджеру.
                        </Text>
                    </div>

                    <div className={b('actions')}>
                        <Checkbox size="m" checked={dontShowAgain} onChange={onCheckboxChange}>
                            Больше не показывать
                        </Checkbox>
                        <Button view="action" size="l" onClick={onOk}>
                            Ок, принято
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
